// extracted by mini-css-extract-plugin
export default {"box":"geracaoCSS_box__pOo3r","row":"geracaoCSS_row__nzs2A","column":"geracaoCSS_column__Ooe7-"};